import { render, staticRenderFns } from "./NewsStory.vue?vue&type=template&id=02e57bb8"
import script from "./NewsStory.ts?vue&type=script&lang=ts&external"
export * from "./NewsStory.ts?vue&type=script&lang=ts&external"
import style0 from "./NewsStory.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports